var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicrochipAi = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5V16.5C4.5 18.1569 5.84315 19.5 7.5 19.5H16.5C18.1569 19.5 19.5 18.1569 19.5 16.5V7.5C19.5 5.84315 18.1569 4.5 16.5 4.5H7.5ZM7.5 6C6.67157 6 6 6.67157 6 7.5V16.5C6 17.3284 6.67157 18 7.5 18H16.5C17.3284 18 18 17.3284 18 16.5V7.5C18 6.67157 17.3284 6 16.5 6H7.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 1.5H9V4.5H7.5V1.5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 1.5H12.75V4.5H11.25V1.5Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M15 1.5H16.5V4.5H15V1.5Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 19.5H9V22.5H7.5V19.5Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 19.5H12.75V22.5H11.25V19.5Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M15 19.5H16.5V22.5H15V19.5Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 16.5V15H22.5V16.5H19.5Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 12.75V11.25H22.5V12.75H19.5Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 9V7.5H22.5V9H19.5Z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 16.5V15H4.5V16.5H1.5Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 12.75V11.25H4.5V12.75H1.5Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 9V7.5H4.5V9H1.5Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 8.25V15.75H15.3583V8.25H16.5Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M8.71195 15.75H7.5L10.2232 8.25H11.5423L14.2655 15.75H13.0535L10.9141 9.6123H10.855L8.71195 15.75ZM8.91517 12.813H12.8466V13.7651H8.91517V12.813Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrochipAi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microchip-ai.48ce7ee7911cdfbff13ebf8bb2fcf0ad.svg";